import React, { useState, useContext, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./style.css";
import Footer from "components/Footer/Footer";
import facebook from "Assets/facebook.svg";
import twitter from "Assets/twitter.svg";
import PKButton from "components/Button/Button";
import PresentationCard from "components/PresentationCard/PresentationCard";
import PkCommentBox from "components/Comments/Comments";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Switch from "components/Switch/Switch";
import PlayerVideo from "components/VideoPlayer/VideoPlayerV2";
import { current_unix_stamp, get_current_unix_stamp } from "utils/Helper";
import {
  user_access_level,
  org_friendly_url,
  search_Presentation_API,
  presentation_Creation_API,
  myHeaders_With_Cache_Control,
  myHeaders_Auth_With_Cache_Control,
  HeaderConfig,
  myHeaders_Autorized,
  myHeaders_Authorized,
  user_Status,
  user_Status_Ver,
  apiUrl,
  user_entity_uuid,
} from "Api/Api";
import axios from "axios";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";
import { withRouter } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import Uparrow from "Assets/up-arrow.png";
import Downarrow from "Assets/down-arrow.png";
import { local_routes } from "utils/Routes";
import ContactReportModal from "components/ContactReportModal/ContactReportModal";
import EmbedModal from "components/ContactReportModal/EmbedModal";
import DownloadAssetsButton from "components/DownloadAssetsButton/DownloadAssetsButton";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import home from "Assets/home.svg";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";
import avatar from "Assets/avatarnew.svg";
import button_embed from "Assets/button_embed.png";
import button_report from "Assets/button_report.png";
import { supported_languages } from "utils/supported_languages";

import UserContext from "store/UserContext";

import TipButton from "components/TipButton/TipButton";

import clapping_hands from "Assets/clapping_hands.png";
import laugh_emoji from "Assets/laugh_emoji.png";
import agree from "Assets/agree.png";

import FollowButton from "components/FollowButton/FollowButton";

import { assembleNickname } from "utils/Helper";

const legacy_language_map = {
  en: "en-US", // assuming more US english
  fr: "fr-FR", // assuming more france french
  de: "de-DE",
  hi: "hi-IN",
  it: "it-IT",
  ko: "ko-KR",
  pt: "pt-BR",
  es: "es-US", // assuming more latin american spanish
};

const PlayerPage = (props) => {
  const randomColors = ["#00A885", "#1775BA"];
  const userContext = useContext(UserContext);
  const [is_loader, set_is_loader] = useState(true);
  const [followed, set_followed] = useState(false);
  const [is_owner, set_is_owner] = useState(false);
  const [editable, set_editable] = useState(false);
  const [instant_reaction, set_instant_reaction] = useState({});
  const [show, set_show] = useState(false);
  const [show_embed_modal, set_show_embed_modal] = useState(false);
  const [presentation_reactions, set_presentation_reactions] = useState(null);
  const [presentation_detail, set_presentation_detail] = useState({});
  const [presentation_events_detail, set_presentation_events_detail] = useState(
    []
  );
  const [event_detail, set_event_detail] = useState({});
  const [open, set_open] = useState(false);
  const [user_data, set_user_data] = useState({}); // first presenter
  const [presenter_data_array, set_presenter_data_array] = useState([]); // all presenters
  const [owner_data, set_owner_data] = useState({}); // for presentation owner (creator)
  const [user_avatar_image_url, set_user_avatar_image_url] = useState(null);
  const [legacy_presenters, set_legacy_presenters] = useState(null);
  const [applaud_count, set_applaud_count] = useState(0);
  const [view_count, set_view_count] = useState(0);
  const [like_loader, set_like_loader] = useState(false);
  const [label, set_label] = useState("like");
  const [categories, set_categories] = useState([]);
  const [show_next_events, set_show_next_events] = useState(true);
  const [friendly_url, set_friendly_url] = useState(null);
  const [next_presentation_friendly_url, set_next_presentation_friendly_url] =
    useState("");
  const [page_title, set_page_title] = useState("PechaKucha 20x20");

  //   RECENTLY ADDED BY ME
  const [embed_html, set_embed_html] = useState(null);
  const [allow_download_assets, set_allow_download_assets] = useState(false);

  let workspace_base_url = "";
  if (org_friendly_url) {
    workspace_base_url = local_routes.workspace + "/" + org_friendly_url;
  }

  let reaction_api_lock = false;
  let enable_reactions = false;
  let current_video_time = null;

  useEffect(() => {
    APIPromises();
  }, [props.location.pathname]);

  const getRemoteVttBlob = async (remote_url) => {
    let xhr = new XMLHttpRequest();

    return new Promise(function (resolve, reject) {
      xhr.open("GET", remote_url, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = function () {
        // 'this' refers to the XMLHttpRequest defined above
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequestEventTarget/onload
        let arrayBufferView = new Uint8Array(this.response);
        let blob = new window.Blob([arrayBufferView], { type: "text/vtt" });
        resolve(blob);
      };
      xhr.send();
    });
  };

  const APIPromises = async (data) => {
    set_is_loader(true);

    let received_params;
    if (data !== undefined) {
      received_params = data;
    } else {
      received_params = props.match.params;
    }
    received_params.friendly_url = received_params.friendly_url.toLowerCase();
    set_friendly_url(received_params.friendly_url);

    //API Calls GET /rest/presentations
    let new_state = {};
    new_state.allow_download_assets = false;
    new_state.is_owner = false;
    new_state.assets_array = [];

    let axios_promises = [
      axios.get(
        `${presentation_Creation_API}/${received_params.friendly_url}`,
        myHeaders_Authorized
      ),
      axios.get(
        `${presentation_Creation_API}/${received_params.friendly_url}/users`,
        myHeaders_Authorized
      ),
      axios.get(
        `${presentation_Creation_API}/${received_params.friendly_url}/categories`,
        myHeaders_Authorized
      ),
      axios.get(
        `${presentation_Creation_API}/${received_params.friendly_url}/reactions`,
        myHeaders_Authorized
      ),
      axios.get(
        `${presentation_Creation_API}/${
          received_params.friendly_url
        }/events?do_recursive=true&limit=1&sort_obj=${encodeURIComponent(
          '{"start_time":"desc"}'
        )}&filter_obj=${encodeURIComponent('{"order_integer":{"gte":1}}')}`,
        myHeaders_Authorized
      ),
    ];
    if (user_Status === 1 && user_Status_Ver === "1") {
      axios_promises.push(
        axios.get(
          `${apiUrl}users/${user_entity_uuid}/presentations.audience/${received_params.friendly_url}`,
          myHeaders_Auth_With_Cache_Control
        )
      );
    }
    let [
      presentationRes,
      userDataRes,
      presentationCategories,
      presentationReactions,
      presentationEvents,
      likeDataApiRes,
    ] = await Promise.all(axios_promises);

    let categories_title_tag_text = "";
    let full_name = "";
    if (presentationCategories.data) {
      set_categories(presentationCategories.data);
      new_state.categories = presentationCategories.data;
      // we want first or first and second categories in title. someday we want most popluar categories but we don't have that yet.
      if (presentationCategories.data[0]) {
        categories_title_tag_text =
          presentationCategories.data[0].entity_name + " ";
      }
      if (presentationCategories.data[1]) {
        categories_title_tag_text =
          categories_title_tag_text +
          "& " +
          presentationCategories.data[1].entity_name +
          " ";
      }

      // pick random colors
      new_state.categories.forEach((element) => {
        element.category_color =
          randomColors[Math.floor(Math.random() * randomColors.length)];
      });
    }

    if (presentationRes.data && presentationRes.data.entity_uuid) {
      if (presentationRes.data.presentation_subtitle_vtt_url) {
        let cc_vtt_blob = await getRemoteVttBlob(
          presentationRes.data.presentation_subtitle_vtt_url
        );
        let cc_vtt_local_file_url = window.URL.createObjectURL(cc_vtt_blob);
        presentationRes.data.cc_vtt_local_file_url = cc_vtt_local_file_url;
        if (presentationRes.data.language_abbreviation) {
          if (
            presentationRes.data.language_abbreviation in legacy_language_map
          ) {
            presentationRes.data.language_abbreviation =
              legacy_language_map[presentationRes.data.language_abbreviation];
          }
          let language_obj = supported_languages.find(
            (item) => item.type === presentationRes.data.language_abbreviation
          );
          if (language_obj) {
            presentationRes.data.subtitle_title = language_obj.subtitle_title;
          } else {
            presentationRes.data.subtitle_title = "Dothraki / Klingon";
          }
        }
      }

      presentationRes.data.categories_title_tag_text =
        categories_title_tag_text;

      if (presentationRes.data.legacy_presenters) {
        set_legacy_presenters(presentationRes.data.legacy_presenters);
        full_name = presentationRes.data.legacy_presenters;
      }

      if (presentationRes.data.applaud_count) {
        new_state.applaudCount = presentationRes.data.applaud_count;
      } else {
        new_state.applaudCount = 0;
      }
      set_applaud_count(new_state.applaudCount);

      if (presentationRes.data.view_count) {
        new_state.viewCount = presentationRes.data.view_count;
      } else {
        new_state.viewCount = 0;
      }
      set_view_count(new_state.viewCount);

      if (presentationRes.data.image_url) {
        let pad_color = "black";
        let image_size = "1280x720";
        if (presentationRes.data.pad_color) {
          pad_color = presentationRes.data.pad_color;
        }
        let array = presentationRes.data.image_url.split("/");
        presentationRes.data.poster_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/pad${pad_color}_${image_size}/${array[5]}`;
      }
      new_state.presentationDetail = presentationRes.data;

      let date_options = { year: "numeric", month: "short", day: "numeric" };
      let created_date = new Date(
        new_state.presentationDetail.created_time * 1000
      );
      let display_date = created_date.toLocaleDateString(
        undefined,
        date_options
      );
      new_state.presentationDetail.created_date_display = display_date;
      set_presentation_detail(new_state.presentationDetail);
      // View Count API starts
      axios.post(
        `${presentation_Creation_API}/${presentationRes.data.entity_uuid}/incrementCount?count_type=view`,
        {},
        HeaderConfig
      );
    } else {
      // did not find presentation! Not good!
      set_is_loader(false);
      return;
    }

    if (
      (!presentationRes.data.create_presentation_video_start_time ||
        presentationRes.data.create_presentation_video_start_time <
          get_current_unix_stamp() - 600) &&
      (!presentationRes.data.create_presentation_transcript_start_time ||
        presentationRes.data.create_presentation_transcript_start_time <
          get_current_unix_stamp() - 600)
    ) {
      new_state.editable = true;
      set_editable(true);
    }

    if (userDataRes.data) {
      let tmp_presenters_array = userDataRes.data.filter(
        (element) =>
          element.xref_data && element.xref_data.presenter_integer >= 1
      );
      tmp_presenters_array = tmp_presenters_array.sort((a, b) =>
        a.xref_data.presenter_integer > b.xref_data.presenter_integer ? 1 : -1
      );
      let tmp_owners_array = userDataRes.data.filter(
        (element) =>
          element.xref_data && element.xref_data.entity_owner_integer >= 1
      );
      if (
        tmp_owners_array.some(
          (element) => element.entity_uuid === user_entity_uuid
        )
      ) {
        //console.log("FOUND OWNER");
        new_state.is_owner = true;
        set_is_owner(true);
        new_state.allow_download_assets = true;
      }

      // get presentation owner / creator
      tmp_owners_array.forEach((item) => {
        if (item.xref_data.entity_owner_integer === 1) {
          new_state.ownerData = item;
          set_owner_data(item);
        }
      });

      if (tmp_presenters_array.length > 0) {
        let presenter_obj = tmp_presenters_array[0];
        let nickname = assembleNickname(presenter_obj);

        new_state.userData = presenter_obj;
        if (nickname) {
          full_name = nickname;
          new_state.userData.full_name = nickname;
        } else {
          new_state.userData.full_name = "Unknown";
        }
        set_user_data((user_data) => ({
          user_data,
          full_name: new_state.userData.full_name,
        }));
        if (presenter_obj.avatar_image_url) {
          let array = presenter_obj.avatar_image_url.split("/");
          new_state.avatarImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_125x125/${array[5]}`;
        }

        // now do same for all presenters
        tmp_presenters_array.forEach((item) => {
          let nickname = assembleNickname(item);

          if (nickname) {
            full_name = nickname;
            item.full_name = nickname;
          } else {
            item.full_name = "Unknown";
          }
          if (item.avatar_image_url) {
            let array = item.avatar_image_url.split("/");
            item.avatarImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_125x125/${array[5]}`;
          }
        });
        new_state.presenterDataArray = tmp_presenters_array;
        set_presenter_data_array(tmp_presenters_array);
      }
    }

    if (user_access_level === "admin" || workspace_base_url) {
      set_allow_download_assets(true);
      new_state.allow_download_assets = true;
    }

    if (
      enable_reactions &&
      presentationReactions.data &&
      Object.keys(presentationReactions.data).length > 0
    ) {
      new_state.presentation_reactions = presentationReactions.data;
    } else {
      new_state.presentation_reactions = null;
    }

    if (user_Status === 1 && likeDataApiRes && likeDataApiRes.data) {
      if (likeDataApiRes.data.applauded_time) {
        new_state.label = "unlike";
      } else {
        new_state.label = "like";
      }
      set_label(new_state.label);

      if (likeDataApiRes.data.favorited_time) {
        new_state.followed = true;
      } else {
        new_state.followed = false;
      }
      set_followed(new_state.followed);
    }

    if (!full_name) {
      full_name = "PechaKucha";
    }
    new_state.page_title =
      full_name +
      " " +
      categories_title_tag_text +
      " Video Presentation: " +
      new_state.presentationDetail.entity_name;

    set_page_title(new_state.page_title);

    new_state.embed_html = generateEmbedHtml(received_params.friendly_url);
    set_embed_html(generateEmbedHtml(received_params.friendly_url));

    // sort categories by entity_name
    new_state.categories = new_state.categories.sort((a, b) =>
      a.entity_name > b.entity_name ? 1 : -1
    );
    set_categories(new_state.categories);

    if (userContext.user_info && userContext.user_info.avatar_image_url) {
      let array = userContext.user_info.avatar_image_url.split("/");
      new_state.user_avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
    }
    set_user_avatar_image_url(new_state.user_avatar_image_url);

    if (presentationEvents.data.length > 0) {
      new_state.eventDetail = { ...presentationEvents.data[0] };

      // build event section data
      if (new_state.eventDetail.start_time) {
        let date_options = { year: "numeric", month: "long", day: "numeric" };
        let event_date = new Date(new_state.eventDetail.start_time * 1000);
        let display_date = event_date
          .toLocaleDateString("en-US", date_options)
          .toUpperCase(); // September 17, 2016
        if (new_state.eventDetail.start_time < current_unix_stamp) {
          new_state.eventDetail.presentation_date_display =
            "PRESENTED ON " + display_date;
        } else {
          new_state.eventDetail.presentation_date_display =
            "SCHEDULED FOR " + display_date;
        }
      }
      new_state.eventDetail.event_name_display = "";
      if (
        new_state.eventDetail.locations &&
        new_state.eventDetail.locations[0]
      ) {
        new_state.eventDetail.location_display =
          new_state.eventDetail.locations[0].entity_name.toUpperCase();
        new_state.eventDetail.city_friendly_url =
          new_state.eventDetail.locations[0].friendly_url;
        if (new_state.eventDetail.volume_integer) {
          new_state.eventDetail.event_name_display =
            new_state.eventDetail.locations[0].entity_name.toUpperCase() +
            " VOL " +
            new_state.eventDetail.volume_integer;
          if (
            new_state.eventDetail.entity_name &&
            new_state.eventDetail.entity_name.toUpperCase() !==
              new_state.eventDetail.event_name_display
          ) {
            new_state.eventDetail.event_name_display +=
              ' "' + new_state.eventDetail.entity_name.toUpperCase() + '"';
          }
        }
      }
      if (
        !new_state.eventDetail.event_name_display &&
        new_state.eventDetail.entity_name
      ) {
        new_state.eventDetail.event_name_display =
          new_state.eventDetail.entity_name.toUpperCase();
      }
    } else {
      new_state.eventDetail = {};
    }
    set_event_detail(new_state.eventDetail);

    set_presentation_events_detail([]);
    new_state.presentationEventsDetail = [];

    // get the page displaying faster
    new_state.isLoader = false;
    set_is_loader(false);

    // now do additional API calls to fill in event info, and also additional presenter info
    let additional_api_promises = [];
    let additional_api_promise_types = [];

    if (user_Status === 1 && user_Status_Ver === "1") {
      new_state.presenterDataArray.forEach((element) => {
        additional_api_promises.push(
          axios.get(
            `${apiUrl}users/${user_entity_uuid}/users.audience/${element.entity_uuid}`,
            myHeaders_Auth_With_Cache_Control
          )
        );
        additional_api_promise_types.push("users_audience");
      });
    }

    if (presentationEvents.data) {
      // JBB - 7/2/2020 - changed this so we just have the event - now get presentations (and presenters) from API
      if (presentationEvents.data.length > 0) {
        let event_uuid = presentationEvents.data[0].entity_uuid;
        additional_api_promises.push(
          axios.get(
            `${apiUrl}events/${event_uuid}/presentations?do_recursive=true&sort_obj=${encodeURIComponent(
              '{"order_integer":"asc"}'
            )}&filter_obj=${encodeURIComponent('{"order_integer":{"gte":1}}')}`
          )
        );
        additional_api_promise_types.push("event_presentations");
      } else {
        //JBB 10/16/2019 - get related presentations via category
        if (new_state.categories.length > 0) {
          for (let category of new_state.categories) {
            let params = {
              categories_uuid: category.entity_uuid,
              categories_text: category.entity_name,
              sort_by: "view_count",
              sort_order: "DESC",
              limit: 15,
            };

            additional_api_promises.push(
              axios.get(`${search_Presentation_API}`, {
                params,
                ...HeaderConfig,
              })
            );
            additional_api_promise_types.push("category_search");
          }
        }
      }
    }
    let max_related_presentations = 15;

    let additional_api_promises_results = await Promise.all(
      additional_api_promises
    );
    additional_api_promises_results.forEach((response, index) => {
      if (additional_api_promise_types[index] === "event_presentations") {
        let pk_slot = presentationEvents.data[0].xref_data.order_integer;
        let before_slice = response.data.slice(0, pk_slot - 1);
        let after_slice = response.data.slice(pk_slot);

        set_presentation_events_detail(after_slice.concat(before_slice));
        new_state.presentationEventsDetail = after_slice.concat(before_slice);
      } else if (additional_api_promise_types[index] === "users_audience") {
        // are we following? are we friends? are we a patron?
        if (response.data.favorited_time) {
          // following
          new_state.presenterDataArray[index].following = true;
        }
        if (response.data.friended_time) {
          // friended
          new_state.presenterDataArray[index].friended = true;
        }
        if (response.data.tips && response.data.tips.length > 0) {
          // friended
          new_state.presenterDataArray[index].tipped = true;
        }
      } else if (additional_api_promise_types[index] === "category_search") {
        if (response.data.search_query_results.length > 0) {
          if (
            response.data.search_query_results[0].entity_info.friendly_url !==
            received_params.friendly_url
          ) {
            if (
              !new_state.presentationEventsDetail.some(
                (item) =>
                  item.entity_uuid ===
                  response.data.search_query_results[0].entity_info.entity_uuid
              )
            ) {
              if (
                new_state.presentationEventsDetail.length <
                max_related_presentations
              ) {
                set_presentation_events_detail((presentation_events_detail) => [
                  ...presentation_events_detail,
                  response.data.search_query_results.shift().entity_info,
                ]);
                new_state.presentationEventsDetail.push(
                  response.data.search_query_results.shift().entity_info
                );
              }
            }
          }
        }
      }
    });

    if (new_state.presentationEventsDetail.length > 0) {
      set_next_presentation_friendly_url(
        new_state.presentationEventsDetail[0].friendly_url
      );
    }
  };

  const generateEmbedHtml = (tmp_friendly_url) => {
    let origin = window.location.origin;
    let embed_html =
      "<iframe scrolling='no' width='500' height='430' src='" +
      origin +
      "/embed/presentations/" +
      tmp_friendly_url +
      "' frameborder='0'></iframe>";
    return embed_html;
  };

  const onVideoPlayComplete = async (userData) => {
    if (userData === true && show_next_events) {
      if (next_presentation_friendly_url) {
        props.history.push(
          workspace_base_url +
            local_routes.presentations +
            "/" +
            next_presentation_friendly_url
        );
      }
    }
  };

  // moreEventCheck will facebook_get_access_token_api
  const toggleDiv = () => {
    set_show_next_events((is_showing) => !is_showing);
  };

  const handleClick = () => {
    if (user_Status === 1) {
      // Applaud Count API starts
      set_like_loader(true);
      let decrement_flag = "";
      let new_label = "unlike";
      if (label === "unlike") {
        decrement_flag = "&decrement=true";
        new_label = "like";
      }
      axios
        .post(
          `${presentation_Creation_API}/${presentation_detail.entity_uuid}/incrementCount?count_type=applaud${decrement_flag}`,
          {},
          myHeaders_Autorized
        )
        .then((res) => {
          if (
            res.data.message ===
            "count not incremented - user has already done this action"
          ) {
            set_like_loader(false);
            return null;
          }
          set_applaud_count(res.data.new_count);
          set_label(new_label);
          set_like_loader(false);

          // now bust cache
          axios.all([
            axios.get(
              `${presentation_Creation_API}/${props.match.params.friendly_url}`,
              myHeaders_With_Cache_Control
            ),
            axios.get(
              `${apiUrl}users/${user_entity_uuid}/presentations.audience?filter_obj=${encodeURIComponent(
                '{"applauded_time":{"gte":1}}'
              )}&attributes_array=${encodeURIComponent('["friendly_url"]')}`,
              myHeaders_Auth_With_Cache_Control
            ),
          ]);
        });
      // Applaud Count API ends
    }
  };

  // Toggles modal show
  const showEmbedModal = () => {
    set_show_embed_modal(true);
    return null;
  };
  // Toggles modal hide
  const hideEmbedModal = () => {
    set_show_embed_modal(false);
    return null;
  };

  // Toggles modal show
  const showModal = () => {
    set_show(true);
    return null;
  };
  // Toggles modal hide
  const hideModal = () => {
    set_show(false);
    return null;
  };

  const reactionClick = async (reaction_type) => {
    console.log("reactionClick", reaction_type, current_video_time);
    if (current_video_time === null) {
      return;
    }

    let tmp_presentation_reactions = { ...presentation_reactions };

    let reaction_time = Math.floor(current_video_time) - 1; // just in case there is a slit-second timing issue
    let save_reaction_time = Math.floor(current_video_time);

    if (
      tmp_presentation_reactions[reaction_type] &&
      tmp_presentation_reactions[reaction_type][reaction_time]
    ) {
      tmp_presentation_reactions[reaction_type][reaction_time]++;
    } else if (tmp_presentation_reactions[reaction_type]) {
      tmp_presentation_reactions[reaction_type][reaction_time] = 1;
    } else {
      tmp_presentation_reactions[reaction_type] = {
        [reaction_time]: 1,
      };
    }
    set_presentation_reactions(tmp_presentation_reactions);
    set_instant_reaction(reaction_type + "." + current_video_time);

    if (reaction_api_lock) {
      console.log("API locked - skipping POST");
      return;
    }

    // now POST to database
    reaction_api_lock = true;
    await axios.post(
      `${apiUrl}presentations/${presentation_detail.entity_uuid}/audienceReaction?reaction_type=${reaction_type}&reaction_time=${save_reaction_time}`
    );
    // bust cache
    axios.get(
      `${presentation_Creation_API}/${props.match.params.friendly_url}/reactions`,
      myHeaders_Auth_With_Cache_Control
    );
    reaction_api_lock = false;
  };

  const onUpdateVideoTime = (cur_video_time) => {
    current_video_time = cur_video_time;
  };

  const renderPresenter = (userData) => {
    return (
      <div key={userData.entity_uuid} className="video-author">
        {userData.status_code === 1 && userData.friendly_url ? (
          <div className="user-details">
            <div className="avatar-profile">
              <Link
                to={`${workspace_base_url}${local_routes.users}/${userData.friendly_url}`}
              >
                <img
                  src={
                    userData.avatarImg !== undefined &&
                    userData.avatarImg !== null
                      ? userData.avatarImg
                      : avatar
                  }
                  alt="img"
                  className="img-fluid rounded-circle"
                />
              </Link>
              {(userData.access_level === "admin" ||
                userData.account_level === "private") && (
                <TipButton
                  style={{ marginLeft: "5px", marginTop: "5px" }}
                  entity_info={{ entity_type: "users", ...userData }}
                />
              )}
            </div>
            <Link
              to={`${workspace_base_url}${local_routes.users}/${userData.friendly_url}`}
            >
              <div className="user-profile">
                <h6>
                  {userData.full_name}

                  {userData.tipped && (
                    <span
                      data-tip="You are a tipper and a patron! Thank you!"
                      style={{
                        verticalAlign: "text-bottom",
                        color: "gold",
                        display: "inline-block",
                        fontSize: "smaller",
                        marginLeft: "5px",
                      }}
                    >
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <ReactTooltip />
                    </span>
                  )}
                </h6>

                <span>{userData["description"]}</span>
              </div>
            </Link>
          </div>
        ) : (
          <div className="user-details">
            <div className="avatar-profile">
              <img
                src={
                  userData.avatarImg !== undefined &&
                  userData.avatarImg !== null
                    ? userData.avatarImg
                    : avatar
                }
                alt="img"
                className="img-fluid rounded-circle"
              />
            </div>
            <div className="user-profile">
              <h6>{userData.full_name}</h6>
              <span>{userData["description"]}</span>
            </div>
          </div>
        )}
      </div>
    );
  };

  let private_indicator = "";
  if (
    presentation_detail.public_status &&
    presentation_detail.public_status === "super_private"
  ) {
    private_indicator = (
      <span
        style={{
          verticalAlign: "super",
          fontSize: "x-small",
          color: "#E50114",
        }}
      >
        {" "}
        PRIVATE
      </span>
    );
  }

  if (is_loader) {
    return <FullPageSpinner />;
  } else {
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>{page_title}</title>
          <meta
            name="description"
            content={presentation_detail["description"].replace(/<[^>]+>/g, "")}
          />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@PechaKucha" />
          {user_data && user_data.twitter_handle && (
            <meta
              name="twitter:creator"
              content={`@${user_data.twitter_handle}`}
            />
          )}
          <meta property="og:image" content={presentation_detail.poster_url} />
          <meta
            property="og:video"
            content={presentation_detail.presentation_video_url}
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={
              window.location.origin +
              local_routes.presentations +
              "/" +
              presentation_detail.friendly_url
            }
          />
          <meta
            property="og:title"
            content={"PechaKucha: " + presentation_detail.entity_name}
          />
          <meta
            property="og:description"
            content={presentation_detail["description"].replace(/<[^>]+>/g, "")}
          />
        </Helmet>
        <div className="main-section">
          {/* Body section starts here */}
          <section className="player-page">
            <div className="container">
              <div className="player-page-body">
                <Row>
                  <Col sm={12} md={8} lg={8}>
                    <div style={{ marginTop: "0px" }} className="video-player">
                      <PlayerVideo
                        presentation_data={presentation_detail}
                        user_avatar_image_url={user_avatar_image_url}
                        presentation_reactions={presentation_reactions}
                        instant_reaction={instant_reaction}
                        onUpdateVideoTime={onUpdateVideoTime}
                        autoPlayStatus={true}
                        onClickVideoPlayComplete={onVideoPlayComplete}
                        hd_allowed={
                          user_access_level === "admin" ||
                          workspace_base_url ||
                          (owner_data.account_level &&
                            owner_data.account_level === "private")
                        }
                      />
                    </div>
                    <div className="video-det">
                      <Row>
                        <Col lg="9" xs="8">
                          <h1 style={{ marginTop: "0px" }}>
                            {presentation_detail.entity_name}
                            {private_indicator}
                          </h1>
                        </Col>

                        <Col
                          style={{
                            textAlign: "right",
                            paddingRight: "15px",
                            paddingLeft: "0px",
                          }}
                          lg="3"
                          xs="4"
                        >
                          {is_owner && editable && (
                            <Link
                              data-tip={
                                presentation_detail.organizations_uuid &&
                                !workspace_base_url &&
                                "Please Edit from Team View"
                              }
                              to={{
                                pathname: `${workspace_base_url}${local_routes.pkcreation}/${presentation_detail.entity_uuid}/description`,
                                data: {
                                  source: {
                                    referrer: props.location.pathname,
                                  },
                                },
                              }}
                            >
                              <Button
                                disabled={
                                  presentation_detail.organizations_uuid &&
                                  !workspace_base_url
                                }
                                variant="pkprimary"
                                style={{
                                  marginRight: "5px",
                                  marginBottom: "1px",
                                }}
                              >
                                Edit
                              </Button>
                            </Link>
                          )}
                          {!is_owner &&
                            editable &&
                            user_access_level === "admin" && (
                              <Link
                                data-tip={
                                  presentation_detail.organizations_uuid &&
                                  !workspace_base_url &&
                                  "Please Edit from Team View"
                                }
                                to={{
                                  pathname: `${workspace_base_url}${local_routes.pkcreation}/${presentation_detail.entity_uuid}/description`,
                                  data: {
                                    source: {
                                      referrer: props.location.pathname,
                                    },
                                  },
                                }}
                              >
                                <Button
                                  disabled={
                                    presentation_detail.organizations_uuid &&
                                    !workspace_base_url
                                  }
                                  variant="pkprimary"
                                  style={{
                                    marginRight: "5px",
                                    marginBottom: "1px",
                                  }}
                                >
                                  Edit as Admin
                                </Button>
                              </Link>
                            )}
                          <FollowButton
                            entity_info={{
                              entity_type: "presentations",
                              ...presentation_detail,
                            }}
                            followed={followed}
                          />
                        </Col>

                        {enable_reactions &&
                        user_Status &&
                        user_Status_Ver === "1" ? (
                          <Col
                            style={{
                              textAlign: "right",
                              paddingRight: "15px",
                              paddingLeft: "0px",
                            }}
                            lg="2"
                            xs="3"
                          >
                            <img
                              data-tip="Laughing"
                              style={{
                                marginRight: "2px",
                                cursor: "pointer",
                              }}
                              onClick={() => reactionClick("laugh")}
                              width="25"
                              height="25"
                              src={laugh_emoji}
                              alt="img"
                            />
                            <img
                              data-tip="Applause"
                              style={{
                                marginRight: "2px",
                                cursor: "pointer",
                              }}
                              onClick={() => reactionClick("clap")}
                              width="25"
                              height="25"
                              src={clapping_hands}
                              alt="img"
                            />
                            <img
                              data-tip="Agree"
                              style={{
                                marginRight: "2px",
                                cursor: "pointer",
                              }}
                              onClick={() => reactionClick("agree")}
                              width="25"
                              height="25"
                              src={agree}
                              alt="img"
                            />
                            <ReactTooltip place="bottom" />
                          </Col>
                        ) : null}

                        {enable_reactions &&
                          (!user_Status || user_Status_Ver !== "1") && (
                            <Col
                              style={{
                                textAlign: "right",
                                paddingRight: "15px",
                                paddingLeft: "0px",
                              }}
                              lg="2"
                              xs="3"
                            >
                              <img
                                data-tip="Signup or Login to show you are Laughing"
                                style={{
                                  marginRight: "2px",
                                  cursor: "pointer",
                                }}
                                width="25"
                                height="25"
                                src={laugh_emoji}
                                alt="img"
                              />
                              <img
                                data-tip="Signup or Login to show your Applause"
                                style={{
                                  marginRight: "2px",
                                  cursor: "pointer",
                                }}
                                width="25"
                                height="25"
                                src={clapping_hands}
                                alt="img"
                              />
                              <img
                                data-tip="Signup or Login to show that you Agree"
                                style={{
                                  marginRight: "2px",
                                  cursor: "pointer",
                                }}
                                width="25"
                                height="25"
                                src={agree}
                                alt="img"
                              />
                              <ReactTooltip place="bottom" />
                            </Col>
                          )}
                      </Row>
                      {!workspace_base_url && categories.length !== 0 ? (
                        <div>
                          {categories.map((item) => (
                            <NavLink
                              key={item.entity_uuid}
                              to={`${workspace_base_url}${local_routes.categories}/${item.friendly_url}`}
                            >
                              <h2>
                                <PKButton
                                  key={item.entity_uuid}
                                  theme="btn-global btn-green btn-borderRadius btn-space"
                                  style={{
                                    backgroundColor: item.category_color,
                                  }}
                                >
                                  {item.entity_name}
                                </PKButton>
                              </h2>
                            </NavLink>
                          ))}
                        </div>
                      ) : null}
                      <div className="video-options">
                        <div className="left">
                          <div className="playerSocialIcons">
                            {/* Modal section */}
                            <Modal
                              size="md"
                              show={show_embed_modal}
                              onHide={hideEmbedModal}
                              className="modal-contact-custom"
                            >
                              <div>
                                <EmbedModal
                                  modalText="Copy and Paste this HTML into your site"
                                  modalHtml={embed_html}
                                />
                                <div>
                                  <PKButton
                                    theme="contact-button"
                                    OnClickMet={hideEmbedModal}
                                  >
                                    x
                                  </PKButton>
                                </div>
                              </div>
                            </Modal>

                            {!workspace_base_url && !private_indicator && (
                              <div
                                style={{
                                  paddingBottom: "1px",
                                  paddingRight: "10px",
                                }}
                                onClick={showEmbedModal}
                                href="#"
                              >
                                <img src={button_embed} alt="embed-img" />
                              </div>
                            )}
                            {allow_download_assets ? (
                              <div style={{ paddingRight: "10px" }}>
                                <DownloadAssetsButton
                                  entity_info={{
                                    entity_type: "presentations",
                                    editable: true,
                                    ...presentation_detail,
                                  }}
                                />
                              </div>
                            ) : null}

                            {!workspace_base_url && (
                              <React.Fragment>
                                <div>
                                  <FacebookShareButton
                                    url={
                                      window.location.origin +
                                      local_routes.presentations +
                                      "/" +
                                      presentation_detail.friendly_url
                                    }
                                    quote={presentation_detail.entity_name}
                                    className="Demo__some-network__share-button"
                                  >
                                    <img
                                      src={facebook}
                                      alt="img"
                                      className="share-icon"
                                    />
                                  </FacebookShareButton>
                                </div>
                                <div>
                                  <TwitterShareButton
                                    url={
                                      window.location.origin +
                                      local_routes.presentations +
                                      "/" +
                                      presentation_detail.friendly_url
                                    }
                                    title={presentation_detail.entity_name}
                                    className="Demo__some-network__share-button"
                                  >
                                    <img
                                      src={twitter}
                                      alt="img"
                                      className="share-icon"
                                    />
                                  </TwitterShareButton>
                                </div>
                                <div>
                                  <LinkedinShareButton
                                    url={
                                      window.location.origin +
                                      local_routes.presentations +
                                      "/" +
                                      presentation_detail.friendly_url
                                    }
                                    className="Demo__some-network__share-button"
                                  >
                                    <LinkedinIcon
                                      size={32}
                                      round={true}
                                      alt="img"
                                      className="share-icon"
                                    />
                                  </LinkedinShareButton>
                                </div>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                        <div className="right like-spinner">
                          <p>{presentation_detail.created_date_display}</p>
                          {view_count > 10 && (
                            <p>
                              <i className="fa fa-eye"></i>
                              {view_count}
                            </p>
                          )}
                          <p>
                            <i className="fa fa-heart"></i>
                            {applaud_count}
                          </p>
                          {user_Status === 1 && (
                            <React.Fragment>
                              {like_loader === true ? (
                                <ActivityIndicator
                                  theme="button-Loader-Minimal likeInPlayer"
                                  themeSpinner="spinner-border"
                                />
                              ) : (
                                <p
                                  onClick={handleClick}
                                  href="#"
                                  className="like-label"
                                >
                                  {label}
                                </p>
                              )}
                            </React.Fragment>
                          )}

                          <Modal
                            size="md"
                            show={show}
                            onHide={hideModal}
                            className="modal-contact-custom"
                          >
                            <div>
                              <ContactReportModal modalText="Please use the 'Support' button in the lower right" />
                              <div>
                                <PKButton
                                  theme="contact-button"
                                  OnClickMet={hideModal}
                                >
                                  x
                                </PKButton>
                              </div>
                            </div>
                          </Modal>
                          <p
                            style={{ paddingRight: 15 }}
                            onClick={showModal}
                            href="#"
                          >
                            <img src={button_report} alt="report-img" />
                          </p>
                        </div>
                      </div>
                      {legacy_presenters !== null ? (
                        <div className="video-authors video-author">
                          <div className="author-details">
                            <div className="authorProfile">
                              <h6>{legacy_presenters}</h6>
                            </div>
                          </div>
                        </div>
                      ) : (
                        presenter_data_array.length > 0 && (
                          <div className="video-authors">
                            {presenter_data_array.map((presenterData) =>
                              renderPresenter(presenterData)
                            )}
                          </div>
                        )
                      )}

                      {presentation_detail["description"] !== null &&
                        presentation_detail["description"] !== undefined && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: presentation_detail["description"],
                            }}
                            className="video-description"
                          />
                        )}
                    </div>

                    {((user_Status &&
                      userContext.user_info &&
                      userContext.user_info.entity_uuid) ||
                      !user_Status) &&
                      (!presentation_detail.allow_comments ||
                        presentation_detail.allow_comments === "all") && (
                        <div>
                          {console.log("\n\n RENDERING COMMENTS \n\n ")}
                          <PkCommentBox
                            user_info={userContext.user_info}
                            entity_type="presentations"
                            entity_info={presentation_detail}
                            is_owner={is_owner}
                          />
                        </div>
                      )}

                    {presentation_detail.displayed_transcript !== undefined &&
                      presentation_detail.displayed_transcript !== null && (
                        <div className="video-transcript edit">
                          <img src={Uparrow} className="up-arrow" alt="img" />
                          <img
                            src={Downarrow}
                            className="down-arrow"
                            alt="img"
                          />
                          <div className="transcriptData">
                            <h3>
                              {presentation_detail.entity_name !== undefined &&
                                presentation_detail.entity_name !== null &&
                                presentation_detail.entity_name}{" "}
                              Transcript
                            </h3>
                            <p
                              className="expand-transcript"
                              onClick={() => set_open((is_open) => !is_open)}
                              href="#"
                            >
                              <i className="fa fa-arrows-v"></i> Expand to view
                              full transcript
                            </p>
                          </div>
                          <Collapse in={open}>
                            <p id="example-collapse-text">
                              {presentation_detail.displayed_transcript}
                            </p>
                          </Collapse>
                        </div>
                      )}
                  </Col>
                  <Col sm={12} md={4} lg={4}>
                    {event_detail && event_detail.entity_name ? (
                      <div className="playerevent">
                        <div className="playerevent-area">
                          {event_detail.presentation_date_display ? (
                            <h4>{event_detail.presentation_date_display}</h4>
                          ) : null}
                          {event_detail.location_display ? (
                            <h4>
                              IN{" "}
                              <NavLink
                                activeStyle={{
                                  "text-decoration": "underline",
                                }}
                                to={`${workspace_base_url}${local_routes.cities}/${event_detail.city_friendly_url}`}
                              >
                                {event_detail.location_display}
                              </NavLink>
                            </h4>
                          ) : null}
                          {event_detail.event_name_display ? (
                            <h4>
                              @{" "}
                              <NavLink
                                activeStyle={{
                                  "text-decoration": "underline",
                                }}
                                to={`${workspace_base_url}${local_routes.events}/${event_detail.friendly_url}`}
                              >
                                {event_detail.event_name_display}
                              </NavLink>
                            </h4>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                    <div className="present-grid">
                      {presentation_events_detail.length > 0 ? (
                        <React.Fragment>
                          <Row className="row">
                            <Col sm={12}>
                              <div className="morefromSwitch">
                                {event_detail && event_detail.entity_name ? (
                                  <div className="marTop10">
                                    <h3 className="">More from this event</h3>
                                  </div>
                                ) : (
                                  <div className="marTop10">
                                    <h3 className="">Related presentations</h3>
                                  </div>
                                )}
                                <div>
                                  <Switch
                                    defaultCheck={show_next_events}
                                    onMoreEventCheck={() => toggleDiv()}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <div className="moreFromComponent">
                            {/* Actually displays PresentationCards */}
                            <Event
                              workspace_base_url={workspace_base_url}
                              data={presentation_events_detail}
                            />
                          </div>
                        </React.Fragment>
                      ) : null}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </section>
          {/* Body section ends here */}
          <Footer
            homeImg={home}
            homeImgRef={workspace_base_url ? workspace_base_url : "/"}
            breadcrumbSubPage="Presentations"
          />
        </div>
      </React.Fragment>
    );
  }
};

const Event = (props) => (
  <div>
    {props.data.map((item) => (
      <PresentationCard key={item.entity_uuid} presentation_info={item} />
    ))}
  </div>
);

export default withRouter(PlayerPage);
